module.exports = __webpack_public_path__ + "static/media/home.e68cf400.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/home.png
// module id = 750
// module chunks = 0